// services/everpro/everpro-location/cache.ts â€” cache per-brand (1 merk = 1 akun Everpro)

import type { EverproProvince, EverproCity, EverproDistrict, EverproSubDistrict } from '../everpro-types';


export const everproCache = {
  provinces: null as EverproProvince[] | null,
  cities: new Map<string, EverproCity[]>(),
  districts: new Map<string, EverproDistrict[]>(),
  subDistricts: new Map<string, EverproSubDistrict[]>(),
  postalCode: new Map<string, any>(),
};

export function brandKey(brandId: string, key: string): string {
  return `${brandId}|${key}`;
}
